// extracted by mini-css-extract-plugin
module.exports = {"custom_radio":"radio_custom_radio__61Ah4"};